<script setup lang="ts">
import type { IconName, IconSize } from '@/constants/icons'
import type { Tone } from '~/constants/tones'
import { ICON_CLASSES, ICON_SIZES } from '@/constants/icons'
import { TONE_CLASSES } from '~/constants/tones'

// A tone, or an ink level: the surrounding colour, or full-strength ink. Neutral is faint ink.
type IconTone = Tone | 'current' | 'strong'

const props = withDefaults(
  defineProps<{
    name?: IconName
    icon?: string
    size?: IconSize
    tone?: IconTone
  }>(),
  {
    size: 'md',
    tone: 'current',
  },
)

const iconClass = computed(() => {
  if (props.icon)
    return props.icon
  if (props.name)
    return ICON_CLASSES[props.name]
  return ''
})

const toneClasses: Record<IconTone, string> = {
  ...TONE_CLASSES.text,
  current: '',
  strong: 'text-ink',
}
</script>

<template>
  <span :class="[iconClass, ICON_SIZES[props.size], toneClasses[props.tone]]" aria-hidden="true" />
</template>
